var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_13",
    "data-name": 13,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 568 546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 284,
    y1: -2.05,
    x2: 284,
    y2: 543.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19adff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026ee9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m557,273c0,141.43-107.54,257.72-245.29,271.61-9.11.92-18.36,1.39-27.71,1.39-17.22,0-34.07-1.59-50.4-4.65C106.9,517.71,11,406.56,11,273,11,122.22,133.22,0,284,0s273,122.22,273,273Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.47,245.87v58.5h65.49l-11.14,71.66h-55.11v168.58c-9.11.92-18.36,1.39-27.71,1.39-17.22,0-34.07-1.59-50.4-4.65l-1.59-165.79h-63.15v-71.19h64.84v-65.28c9.33-87.33,83.09-83.09,83.09-83.09l65.38,3.45v60.52h-43.8c-26.75,0-25.9,25.9-25.9,25.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookColorIcon);
export default __webpack_public_path__ + "static/media/FacebookColorIcon.efdf5f2a12e91c67ccb5f41db14dfe24.svg";
export { ForwardRef as ReactComponent };